"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const setPasswordTranslations = {
    setPassword: "Set Password",
    setPasswordMessage: "Enter your password & confirm password",
    newPassword: "New Password",
    setNewPasswordMessage: "Please set your new password",
    setPasswordSuccess: "Password updated successfully! Please login with your new password.",
};
exports.default = setPasswordTranslations;
